import React, { useEffect, useState, useRef } from "react";
import NavBarTop from "../Reusable_Components/NavBarTop";
import LeftNavBar from "../Reusable_Components/LeftNavBar";
import AlertPopUp from "../Reusable_Components/Alert";
import Pagination from "../Reusable_Components/Pagination";
import { GoSearch } from "react-icons/go";
import { Stack } from 'react-bootstrap'
import TableComponent from "../Reusable_Components/TableComponent";
import { ACLS, CEO_GROUP, COMMERCIAL_HEAD_GROUP, FACILITY_MANAGER_GROUP, FINANCE_MANAGER_GROUP, PORTOS_CUSTOMER_GROUP, RECORDS_PER_PAGE_METER_MASTER, TECHNICIAN_GROUP } from "../../Config";
import { useDispatch, useSelector } from "react-redux";
import {
    getAllIssues, getAllIncidents,
    commercialHeadGetAllFacilitiesForNav, handleDocumentLoaderTrue,
    getAllDocumentsForIssues, uploadIssueDocuments, commercialHeadGetBillingEntities
} from "../../Redux/Actions/Actions";
import SearchableDropdown from '../Reusable_Components/SearchableDropdown';
import Loader from '../Reusable_Components/loader';
import { current } from "@reduxjs/toolkit";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import UploadComponent from '../Reusable_Components/UploadComponent';
import axios from 'axios';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { base_url } from "../../utilities";
import { set } from "date-fns";
import { filter, format } from "d3";
import { eleminateSpacesAtStartOfInputField, eleminateSpecialCharactersAtStartOfInputField, formatDateBasedOnValue } from "../Reusable_Components/ReusableFunctions";
import Footer from "../Login/Footer";
import { MdPersonAddAlt1 } from "react-icons/md";
import { useLocation } from "react-router-dom";

export default function FacilityManagerIssuesAndIncidents() {

    const location = useLocation()
    const { props } = location.state || {};


    const [companyList, setCompanyList] = useState([])
    const [isCustomer, setIsCustomer] = useState(false)
    const [selectedIssueCustomer, setSelectedIssueCustomer] = useState('')
    const [selectedIncidentCustomer, setSelectedIncidentCustomer] = useState('')

    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])


    useEffect(() => {
        getAllCompanies()
    }, [])

    const getAllCompanies = () => {
        axios.get(base_url + "customers", {
            params: {
                request_type: "dropdown",
            }
        })
            .then((response) => {
                if (response?.data?.data[0] === 'error') {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                } else {
                    setCompanyList(response?.data?.data);
                }
            })
            .catch((error) => {
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
            });

    }

    useEffect(() => {
        const details = {
            issue_id: props?.entity_details?.issue_id,
            incident_id: props?.entity_details?.incident_id,
            entity_type: props?.entity_type
        }
        if (details?.issue_id) {
            handleViewActionClicked(details)
        } else if (details?.incident_id) {
            handleViewActionClicked(details)
        }
    }, [props])

    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1)
    const [searchText, setSearchText] = useState('')

    const contractApiLoader = useSelector(state => state.contractApiLoader)
    const allIssues = useSelector(state => state.allIssues?.data)
    const allIncidents = useSelector(state => state.allIncidents?.data)
    const currentPaginationPageIssues = useSelector(state => state.allIssues?.info?.page_number);
    const totalRecordsIssues = useSelector(state => state.allIssues?.info?.total_rows);
    const currentPaginationPageIncidents = useSelector(state => state.allIncidents?.info?.page_number);
    const totalRecordsIncidents = useSelector(state => state.allIncidents?.info?.total_rows);


    const [activeTab, setActiveTab] = useState('1');

    const [facilityList, setFacilityList] = useState([]);


    const [issueReportedBy, setIssueReportedBy] = useState("");
    const [requestNumber, setRequestNumber] = useState("");
    const [issueDate, setIssueDate] = useState("");
    const [issueType, setIssueType] = useState("");
    const [issueStatus, setIssueStatus] = useState("pending");
    const [issueDescriptiion, setIssueDescriptiion] = useState("");
    const [immediateActionTaken, setImmediateActionTaken] = useState("");
    const [preventiveActionTaken, setPreventiveActionTaken] = useState("");
    const [comments, setComments] = useState("");

    const [issueClosureBy, setIssueClosureBy] = useState("")

    const [viewClicked, setViewClicked] = useState(false);
    const [editClicked, setEditClicked] = useState(false);

    const allDocumentsForIssues = useSelector(state => state.allDocumentsForIssues)

    useEffect(() => {
        if (allDocumentsForIssues) {
            setDocumentListArray(allDocumentsForIssues)
            setIsLoading(false)
        }
    }, [allDocumentsForIssues])

    useEffect(() => {
        dispatch(commercialHeadGetAllFacilitiesForNav())
        dispatch(commercialHeadGetBillingEntities())
    }, [dispatch]);

    const facilitiesListForNav = useSelector(state => state.facilitiesListForNav);

    useEffect(() => {
        if (facilitiesListForNav) {
            const options = facilitiesListForNav?.map((facility) => `${facility.city}, ${facility.name}`);
            setFacilityList(options);
        }
    }, [facilitiesListForNav]);


    useEffect(() => {
        setIsLoading(false)
        dispatch(getAllIssues(
            {
                search_text: searchText.trim(),
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                    status: issueIncidentStatus
                }
            }
        ))
        dispatch(getAllIncidents(
            {
                search_text: searchText.trim(),
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                    status: issueIncidentStatus
                }
            }
        ))
    }, [dispatch])

    const error = useSelector(state => state?.error)
    const billingEntities = useSelector((state) => state.billingEntities);

    useEffect(() => {
        if (error) {
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error')
            setAlertValue(error?.response?.data?.message)
            setAlertButtons([
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                },
            ])
        }
    }, [error])

    const typesOfTabs = [
        {
            name: "Issues",
            id: "issues"
        },
        {
            name: "Incidents",
            id: "incidents"
        },

    ]
    const [tabType, setTabType] = useState("issues")
    const [isLoading, setIsLoading] = useState(false)

    const onchangeTabType = (value) => {
        setTabType(value)

    }

    const searchFunc = (value) => {
        setSearchText(value)
    }

    const handledPaginationNextClickedIssues = () => {
        dispatch(getAllIssues(
            {
                search_text: searchText.trim(),
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: currentPaginationPageIssues + 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                    status: issueIncidentStatus
                }
            }
        ))
    }

    const handledPaginationPrevClickedIssues = () => {
        dispatch(getAllIssues(
            {
                search_text: searchText.trim(),
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: currentPaginationPageIssues - 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                    status: issueIncidentStatus
                }
            }
        ))
    }


    const handledPaginationNextClickedIncidents = () => {
        dispatch(getAllIncidents(
            {
                search_text: searchText.trim(),
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: currentPaginationPageIncidents + 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                    status: issueIncidentStatus
                }
            }
        ))
    }

    const handledPaginationPrevClickedIncidents = () => {
        dispatch(getAllIncidents(
            {
                search_text: searchText.trim(),
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: currentPaginationPageIncidents - 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                    status: issueIncidentStatus
                }
            }
        ))
    }
    const [selectedfacility, setSelectedFacility] = useState(`${localStorage.getItem("selected_city_name")}, ${localStorage.getItem("selected_facility_name")}`);
    const [selectedFacilityId, setSelectedFacilityId] = useState(localStorage.getItem("selected_facility_id"));
    const [selectedFacilityName, setSelectedFacilityName] = useState(localStorage.getItem("selected_facility_name"));
    const [selectedCityName, setSelectedCityName] = useState(localStorage.getItem("selected_city_name"));
    const [isFacilitySelected, setIsFacilitySelected] = useState(selectedfacility);


    const applyFilterClicked = () => {
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);


        dispatch(getAllIssues(
            {
                search_text: searchText.trim(),
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: {
                    facility_id: selectedFacilityId,
                    status: issueIncidentStatus
                }
            }
        ))
        dispatch(getAllIncidents(
            {
                search_text: searchText.trim(),
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: {
                    facility_id: selectedFacilityId,
                    status: issueIncidentStatus
                }
            }
        ))
    }

    const [issueIncidentStatus, setIssueIncidentStatus] = useState("pending");

    const clearFilterClicked = () => {
        setIssueIncidentStatus("pending");
        setSearchText("");
        dispatch(getAllIssues(
            {
                search_text: "",
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                    status: "pending"
                }
            }
        ))
        dispatch(getAllIncidents(
            {
                search_text: "",
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                    status: "pending"
                }
            }
        ))
    }

    const handleEnable = (each) => {
        return false;
    }

    const [issueId, setIssueId] = useState("")
    const [incidentId, setIncidentId] = useState("")

    const [selectedIssueId, setSelectedIssueId] = useState("")
    const [selectedIncidentId, setSelectedIncidentId] = useState("")

    const [editHistory, setEditHistory] = useState({})


    const handleViewActionClicked = (data) => {
        setIsLoading(true)
        setViewClicked(true)
        const type = data?.entity_type || tabType
        if (type === "issues" || type === "issue") {
            dispatch(getAllDocumentsForIssues(data.issue_id, "issue_id"))
            setSelectedIssueId(data.issue_id)
            axios.get(base_url + `facilities/issues`,
                {
                    params: {
                        filter_condition: JSON.stringify({
                            issue_id: data.issue_id
                        })
                    }
                }
            )
                .then((res) => {
                    setIsLoading(false)
                    setIssueId(res?.data?.data[0]?.issue_id)
                    setIssueReportedBy(res?.data?.data[0]?.issue_reported_by)
                    setIssueDate(res?.data?.data[0]?.issue_date === '0000-00-00' ? "" : res?.data?.data[0]?.issue_date)
                    setIssueTime(res?.data?.data[0]?.issue_time)
                    setIssueType(res?.data?.data[0]?.issue_type)
                    setIssueStatus(res?.data?.data[0]?.status)
                    setIssueDescriptiion(res?.data?.data[0]?.description_of_issue)
                    setImmediateActionTaken(res?.data?.data[0]?.immediate_action)
                    setPreventiveActionTaken(res?.data?.data[0]?.preventive_action)
                    setComments(res?.data?.data[0]?.comments)
                    setIssueClosureBy(res?.data?.data[0]?.closure_done_by)
                    setIssueClosureDate(res?.data?.data[0]?.closure_date_time?.split(" ")[0] === '0000-00-00' ? null : res?.data?.data[0]?.closure_date_time?.split(" ")[0] === undefined ? null : res?.data?.data[0]?.closure_date_time?.split(" ")[0])
                    setIssueClosureTime(res?.data?.data[0]?.closure_date_time?.split(" ")[1])
                    setIssueClosurePreparedBy(res?.data?.data[0]?.closure_prepared_by)
                    setIssueClosureReviewedBy(res?.data?.data[0]?.closure_reviewed_by)
                    setIssueCustomerName(res?.data?.data[0]?.customer_name)
                    setIssueCustomerId(res?.data?.data[0]?.customer_id)
                    setSelectedOurCompany(res?.data?.data[0]?.billing_entity)
                    setSelectedOurCompanyName(res?.data?.data[0]?.billing_entity_name)
                    setCurrentPage(2)
                }
                )
                .catch((err) => {
                    setIsLoading(false)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(err?.response?.data.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                }
                )

            axios.get(base_url + `facilities/issuesJournal`,
                {
                    params: {
                        issue_id: data.issue_id
                    }
                }
            )
                .then((res) => {
                    setEditHistory(res?.data?.data)
                }
                )
                .catch((err) => {
                    console.log(err)
                }
                )

        }
        else {
            setSelectedIncidentId(data.incident_id)
            dispatch(getAllDocumentsForIssues(data.incident_id, "incident_id"))
            axios.get(base_url + `facilities/incidents`,
                {
                    params: {
                        filter_condition: JSON.stringify({
                            incident_id: data.incident_id
                        })
                    }
                }
            )
                .then((res) => {
                    setIsLoading(false)
                    setIncidentId(res?.data?.data[0]?.incident_id)
                    setIncidentReportedBy(res?.data?.data[0]?.incident_reported_by)
                    setIncidentDate(res?.data?.data[0]?.request_raised_on === '0000-00-00' ? "" : res?.data?.data[0]?.request_raised_on)
                    setIncidentTime(res?.data?.data[0]?.incident_time)
                    setIncidentType(res?.data?.data[0]?.issue_type)
                    setIncidentStatus(res?.data?.data[0]?.status)
                    setIncidentDescription(res?.data?.data[0]?.description_of_incident)
                    setIncidentRootCauseAnalysis(res?.data?.data[0]?.root_cause_analysis)
                    setIncidentImmediateActionTaken(res?.data?.data[0]?.immediate_action)
                    setIncidentCorrectiveActionTaken(res?.data?.data[0]?.corrective_action)
                    setIncidentPreventiveActionTaken(res?.data?.data[0]?.preventive_action)
                    setIncidentComments(res?.data?.data[0]?.comments)
                    setIncidentClosureBy(res?.data?.data[0]?.closure_done_by)
                    setIncidentClosureDate(res?.data?.data[0]?.date_and_time_closure?.split(" ")[0] === '0000-00-00' ? "" : res?.data?.data[0]?.date_and_time_closure?.split(" ")[0])
                    setIncidentClosureTime(res?.data?.data[0]?.date_and_time_closure?.split(" ")[1])
                    setIncidentClosurePreparedBy(res?.data?.data[0]?.closure_prepared_by)
                    setIncidentClosureReviewedBy(res?.data?.data[0]?.closure_reviewed_by)
                    setIncidentCustomerName(res?.data?.data[0]?.customer_name)
                    setIncidentCustomerId(res?.data?.data[0]?.customer_id)
                    setSelectedOurCompany(res?.data?.data[0]?.billing_entity)
                    setSelectedOurCompanyName(res?.data?.data[0]?.billing_entity_name)
                    setCurrentPage(3)
                }
                )
                .catch((err) => {
                    setIsLoading(false)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(err?.response?.data.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                }
                )

            axios.get(base_url + `facilities/incidentsJournal`,
                {
                    params: {
                        incident_id: data.incident_id
                    }
                }
            )
                .then((res) => {
                    setEditHistory(res?.data?.data)
                }
                )
                .catch((err) => {
                    console.log(err)
                }
                )

        }

    }

    const handleEditActionClicked = (data) => {

        setIsLoading(true)
        setEditClicked(true)
        if (tabType === "issues") {
            setSelectedIssueId(data.issue_id)
            dispatch(getAllDocumentsForIssues(data.issue_id, "issue_id"))
            axios.get(base_url + `facilities/issues?`,
                {
                    params: {
                        filter_condition: JSON.stringify({
                            issue_id: data.issue_id
                        })
                    }
                }
            )
                .then((res) => {
                    setIsLoading(false)
                    setIssueId(res?.data?.data[0]?.issue_id)
                    setIssueReportedBy(res?.data?.data[0]?.issue_reported_by)
                    setIssueDate(res?.data?.data[0]?.issue_date === '0000-00-00' ? "" : res?.data?.data[0]?.issue_date)
                    setIssueType(res?.data?.data[0]?.issue_type)
                    setIssueTime(res?.data?.data[0]?.issue_time)
                    setIssueStatus(res?.data?.data[0]?.status)
                    setIssueDescriptiion(res?.data?.data[0]?.description_of_issue)
                    setImmediateActionTaken(res?.data?.data[0]?.immediate_action)
                    setPreventiveActionTaken(res?.data?.data[0]?.preventive_action)
                    setComments(res?.data?.data[0]?.comments)
                    setIssueClosureBy(res?.data?.data[0]?.closure_done_by)
                    setIssueClosureDate(res?.data?.data[0]?.closure_date_time?.split(" ")[0] === '0000-00-00' ? null : res?.data?.data[0]?.closure_date_time?.split(" ")[0] === undefined ? null : res?.data?.data[0]?.closure_date_time?.split(" ")[0])
                    setIssueClosureTime(res?.data?.data[0]?.closure_date_time?.split(" ")[1])
                    setIssueClosurePreparedBy(res?.data?.data[0]?.closure_prepared_by)
                    setIssueClosureReviewedBy(res?.data?.data[0]?.closure_reviewed_by)
                    setIssueCustomerName(res?.data?.data[0]?.customer_name)
                    setIssueCustomerId(res?.data?.data[0]?.customer_id)
                    setSelectedOurCompany(res?.data?.data[0]?.billing_entity)
                    setSelectedOurCompanyName(res?.data?.data[0]?.billing_entity_name)
                    setCurrentPage(2)
                }
                )
                .catch((err) => {
                    setIsLoading(false)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(err?.response?.data.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                }
                )
            axios.get(base_url + `facilities/issuesJournal`,
                {
                    params: {
                        issue_id: data.issue_id
                    }
                }
            )
                .then((res) => {
                    setEditHistory(res?.data?.data)
                }
                )
                .catch((err) => {
                    console.log(err)
                }
                )

        }
        else {
            setSelectedIncidentId(data.incident_id)
            dispatch(getAllDocumentsForIssues(data.incident_id, "incident_id"))
            axios.get(base_url + `facilities/incidents?`,
                {
                    params: {
                        filter_condition: JSON.stringify({
                            incident_id: data.incident_id
                        })
                    }
                }
            )
                .then((res) => {
                    setIsLoading(false)
                    setIncidentId(res?.data?.data[0]?.incident_id)
                    setIncidentReportedBy(res?.data?.data[0]?.incident_reported_by)
                    setIncidentDate(res?.data?.data[0]?.request_raised_on === '0000-00-00' ? "" : res?.data?.data[0]?.request_raised_on)
                    setIncidentTime(res?.data?.data[0]?.incident_time)
                    setIncidentType(res?.data?.data[0]?.issue_type)
                    setIncidentStatus(res?.data?.data[0]?.status)
                    setIncidentDescription(res?.data?.data[0]?.description_of_incident)
                    setIncidentRootCauseAnalysis(res?.data?.data[0]?.root_cause_analysis)
                    setIncidentImmediateActionTaken(res?.data?.data[0]?.immediate_action)
                    setIncidentCorrectiveActionTaken(res?.data?.data[0]?.corrective_action)
                    setIncidentPreventiveActionTaken(res?.data?.data[0]?.preventive_action)
                    setIncidentComments(res?.data?.data[0]?.comments)
                    setIncidentClosureBy(res?.data?.data[0]?.closure_done_by)
                    setIncidentClosureDate(res?.data?.data[0]?.date_and_time_closure?.split(" ")[0] === '0000-00-00' ? "" : res?.data?.data[0]?.date_and_time_closure?.split(" ")[0])
                    setIncidentClosureTime(res?.data?.data[0]?.date_and_time_closure?.split(" ")[1])
                    setIncidentClosurePreparedBy(res?.data?.data[0]?.closure_prepared_by)
                    setIncidentClosureReviewedBy(res?.data?.data[0]?.closure_reviewed_by)
                    setIncidentCustomerName(res?.data?.data[0]?.customer_name)
                    setIncidentCustomerId(res?.data?.data[0]?.customer_id)
                    setSelectedOurCompany(res?.data?.data[0]?.billing_entity)
                    setSelectedOurCompanyName(res?.data?.data[0]?.billing_entity_name)
                    setCurrentPage(3)
                }
                )
                .catch((err) => {
                    setIsLoading(false)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(err?.response?.data.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                }
                )
            axios.get(base_url + `facilities/incidentsJournal`,
                {
                    params: {
                        incident_id: data.incident_id
                    }
                }
            )
                .then((res) => {
                    setEditHistory(res?.data?.data)
                }
                )
                .catch((err) => {
                    console.log(err)
                }
                )

        }
    }

    const [isIssueReportedByValid, setIsIssueReportedByValid] = useState(true)
    const [isIssueDateValid, setIsIssueDateValid] = useState(true)
    const [isIssueTypeValid, setIsIssueTypeValid] = useState(true)
    const [isIssueStatusValid, setIsIssueStatusValid] = useState(true)
    const [isIssueDescriptionValid, setIsIssueDescriptionValid] = useState(true)
    const [isImmediateActionTakenValid, setIsImmediateActionTakenValid] = useState(true)
    const [isPreventiveActionTakenValid, setIsPreventiveActionTakenValid] = useState(true)
    const [isCommentsValid, setIsCommentsValid] = useState(true)
    const [isIssueClosureByValid, setIsIssueClosureByValid] = useState(true)

    const [issueCustomerId, setIssueCustomerId] = useState("")
    const [issueCustomerName, setIssueCustomerName] = useState("")
    const [isIssueCustomerNameValid, setIsIssueCustomerNameValid] = useState(true)

    const [incidentCustomerId, setIncidentCustomerId] = useState("")
    const [incidentCustomerName, setIncidentCustomerName] = useState("")
    const [isIncidentCustomerNameValid, setIsIncidentCustomerNameValid] = useState(true)



    const handleIssueReportedByChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))

        setIssueReportedBy(value)
        if (value.length < 3 || value.length > 200) {
            setIsIssueReportedByValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIssueReportedByValid(true)
        }
    }

    const handleRequestNumberChange = (e) => {
        setRequestNumber(e.target.value)
    }

    const handleIssueDateChange = (e) => {
        setIssueDate(e.format("YYYY-MM-DD"))
    }

    const handleIssueTypeChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIssueType(value)
        if (value.length < 3 || value.length > 200) {
            setIsIssueTypeValid(false)
        }
        if (value === "" || (value.length > 3 && value.length <= 200)) {
            setIsIssueTypeValid(true)
        }
    }

    const handleIssueStatusChange = (e) => {
        setIssueStatus(e.target.value)
    }

    const handleIssueDescriptionChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setIssueDescriptiion(value)
        if (value.length < 3) {
            setIsIssueDescriptionValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsIssueDescriptionValid(true)
        }
    }

    const handleImmediateActionTakenChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setImmediateActionTaken(value)
        if (value.length < 3) {
            setIsImmediateActionTakenValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsImmediateActionTakenValid(true)
        }
    }

    const handlePreventiveActionTakenChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setPreventiveActionTaken(value)
        if (value.length < 3) {
            setIsPreventiveActionTakenValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsPreventiveActionTakenValid(true)
        }
    }

    const handleCommentsChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setComments(value)
        if (value.length < 3) {
            setIsCommentsValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsCommentsValid(true)
        }
    }

    const handleIssueClosureByChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIssueClosureBy(value)
        if (value.length < 3 || value.length > 200) {
            setIsIssueClosureByValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIssueClosureByValid(true)
        }
    }

    const handleClearValidations = () => {
        setIsIssueReportedByValid(true)
        setIsIssueDateValid(true)

        setIsIssueTypeValid(true)
        setIsIssueStatusValid(true)
        setIsIssueDescriptionValid(true)
        setIsImmediateActionTakenValid(true)

        setIsPreventiveActionTakenValid(true)
        setIsCommentsValid(true)
        setIsIssueClosureByValid(true)

        setIsIssueCustomerNameValid(true)
        setIsRootCauseAnalysisValid(true)
        setIsCorrectiveActionTakenValid(true)
    }

    const handleSaveIssueClicked = () => {
        setIsLoading(true)
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);
        setIssueIncidentStatus(issueStatus);
        const statusValue = issueStatus

        const data = {
            facility_id: selectedFacilityId,
            facility_name: selectedFacilityName,
            issue_reported_by: issueReportedBy,
            issue_date: issueDate,
            issue_time: issueTime,
            issue_type: issueType,
            status: issueStatus,
            description_of_issue: issueDescriptiion,
            immediate_action: immediateActionTaken,
            preventive_action: preventiveActionTaken,
            comments: comments,
            closure_done_by: issueClosureBy,
            closure_prepared_by: issueClosurePreparedBy,
            closure_reviewed_by: issueClosureReviewedBy,
            closure_date_time: issueClosureDate && issueClosureTime ? `${issueClosureDate} ${issueClosureTime}` : "",
            customer_name: issueCustomerName,
            customer_id: issueCustomerId,
            root_cause_analysis: rootCauseAnalysis,
            corrective_action: correctiveActionTaken,
            billing_entity: selectedOurCompany,
            billing_entity_name: selectedOurCompanyName,

        }

        axios.post(base_url + "facilities/issues", data)
            .then((res) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue("Issue added successfully")
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            setEditClicked(false)
                            setCurrentPage(1)
                            setIssueReportedBy("")
                            setIssueDate("")
                            setIssueTime("")
                            setIssueType("")
                            setIssueStatus("pending")
                            setIssueDescriptiion("")
                            setImmediateActionTaken("")
                            setPreventiveActionTaken("")
                            setComments("")
                            setIssueIncidentStatus(issueStatus)
                            setSelectedIssueId("")
                            setDocumentListArray([])
                            setIssueClosureBy("")
                            setIssueClosureDate("")
                            setIssueClosureTime("")
                            setIssueClosurePreparedBy("")
                            setIssueClosureReviewedBy("")
                            setIssueCustomerName("")
                            setIssueCustomerId("")
                            setRootCauseAnalysis("")
                            setCorrectiveActionTaken("")
                            handleClearValidations()
                            setSelectedIssueCustomer("")
                            setEditHistory({})
                            dispatch(getAllIssues(
                                {
                                    search_text: "",
                                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                                    page_number: 1,
                                    filter_condition: {
                                        facility_id: selectedFacilityId,
                                        status: statusValue
                                    }
                                }
                            ))

                            dispatch(getAllIncidents(
                                {
                                    search_text: "",
                                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                                    page_number: 1,
                                    filter_condition: {
                                        facility_id: selectedFacilityId,
                                        status: statusValue
                                    }
                                }
                            ))
                            setIsLoading(false)


                        }
                    },
                ])
            })
            .catch((err) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(err?.response?.data.message)
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                        }
                    },
                ])
            })

    }

    const handleUpdateIssueClicked = () => {
        setIsLoading(true)
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);
        setIssueIncidentStatus(issueStatus);
        const statusValue = issueStatus

        const data = {
            issue_id: issueId,
            facility_id: selectedFacilityId,
            facility_name: selectedFacilityName,
            issue_reported_by: issueReportedBy,
            issue_date: issueDate,
            issue_time: issueTime,
            issue_type: issueType,
            status: issueStatus,
            description_of_issue: issueDescriptiion,
            immediate_action: immediateActionTaken,
            preventive_action: preventiveActionTaken,
            comments: comments,
            closure_done_by: issueClosureBy,
            closure_date_time: `${issueClosureDate} ${issueClosureTime}`,
            closure_prepared_by: issueClosurePreparedBy,
            closure_reviewed_by: issueClosureReviewedBy,
            customer_name: issueCustomerName,
            customer_id: issueCustomerId,
            root_cause_analysis: rootCauseAnalysis,
            corrective_action: correctiveActionTaken,
            billing_entity: selectedOurCompany,
            billing_entity_name: selectedOurCompanyName,
        }

        axios.put(base_url + "facilities/issues", data)
            .then((res) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue("Issue updated successfully")
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            setEditClicked(false)
                            setCurrentPage(1)
                            setIssueReportedBy("")
                            setIssueDate("")
                            setIssueTime("")
                            setIssueType("")
                            setIssueStatus("pending")
                            setIssueDescriptiion("")
                            setImmediateActionTaken("")
                            setPreventiveActionTaken("")
                            setComments("")
                            setIssueIncidentStatus(issueStatus)
                            setSelectedIssueId("")
                            setDocumentListArray([])
                            setIssueClosureBy("")
                            setIssueClosureDate("")
                            setIssueClosureTime("")
                            setIssueClosurePreparedBy("")
                            setIssueClosureReviewedBy("")
                            setIssueCustomerName("")
                            setIssueCustomerId("")
                            setRootCauseAnalysis("")
                            setCorrectiveActionTaken("")
                            setSelectedOurCompany("")
                            setSelectedOurCompanyName("")
                            setSelectedIssueCustomer("")
                            handleClearValidations()

                            dispatch(getAllIssues(
                                {
                                    search_text: "",
                                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                                    page_number: 1,
                                    filter_condition: {
                                        facility_id: selectedFacilityId,
                                        status: statusValue
                                    }
                                }
                            ))

                            dispatch(getAllIncidents(
                                {
                                    search_text: "",
                                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                                    page_number: 1,
                                    filter_condition: {
                                        facility_id: selectedFacilityId,
                                        status: statusValue
                                    }
                                }
                            ))
                            setIsLoading(false)


                        }
                    },
                ])
            })
            .catch((err) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(err?.response?.data.message)
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                        }
                    },
                ])
            })

    }

    const handleCancelIssueClicked = () => {
        if (viewClicked) {
            setCurrentPage(1)
            setIssueReportedBy("")
            setIssueDate("")
            setIssueType("")
            setIssueStatus("pending")
            setIssueDescriptiion("")
            setImmediateActionTaken("")
            setPreventiveActionTaken("")
            setComments("")
            setCurrentPage(1)
            setViewClicked(false)
            setEditClicked(false)
            setIssueId("")
            setSelectedIssueId("")
            setDocumentListArray([])
            setIssueClosureBy("")
            setIssueClosureDate("")
            setIssueClosureTime("")
            setIssueClosurePreparedBy("")
            setIssueClosureReviewedBy("")
            setIssueCustomerName("")
            setIncidentCustomerId("")
            setRootCauseAnalysis("")
            setCorrectiveActionTaken("")
            setSelectedOurCompany("")
            setSelectedOurCompanyName("")
            setEditHistory({})
            handleClearValidations()
            setSelectedIssueCustomer("")
            setIssueTime("")
        }
        else {
            setAlertShow(true)
            setAlertType('warning')
            setAlertMessage('Warning')
            setAlertValue("Are you sure you want to cancel? The changes you made will not be saved.")
            setAlertButtons([
                {
                    name: 'Yes', action: () => {
                        setAlertShow(false)
                        setCurrentPage(1)
                        setIssueReportedBy("")
                        setIssueDate("")
                        setIssueType("")
                        setIssueTime("")
                        setIssueStatus("pending")
                        setIssueDescriptiion("")
                        setImmediateActionTaken("")
                        setPreventiveActionTaken("")
                        setComments("")
                        setCurrentPage(1)
                        setViewClicked(false)
                        setEditClicked(false)
                        setIssueId("")
                        setSelectedIssueId("")
                        setDocumentListArray([])
                        setIssueClosureBy("")
                        setIssueClosureDate("")
                        setIssueClosureTime("")
                        setIssueClosurePreparedBy("")
                        setIssueClosureReviewedBy("")
                        setIssueCustomerName("")
                        setIssueCustomerId("")
                        setRootCauseAnalysis("")
                        setCorrectiveActionTaken("")
                        setSelectedOurCompany("")
                        setSelectedOurCompanyName("")
                        handleClearValidations()
                        setEditHistory({})
                        setSelectedIssueCustomer("")
                        setSelectedFacilityId(localStorage.getItem("selected_facility_id"))
                        setSelectedCityName(localStorage.getItem("selected_city_name"))
                        setSelectedFacilityName(localStorage.getItem("selected_facility_name"))
                        setSelectedFacility(`${localStorage.getItem("selected_city_name")}, ${localStorage.getItem("selected_facility_name")}`)
                    }
                },
                {
                    name: 'No', action: () => {
                        setAlertShow(false)
                    }
                },
            ])
        }

    }


    const [uploadedFiles, setUploadedFiles] = useState();

    const handleFilesSelected = (files) => {
        const processedFiles = [];
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = function () {
                const base64FileContent = reader.result.split(",")[1];
                const required_id = selectedIssueId
                const processedFile = {
                    file_content: base64FileContent,
                    object_type: "issue_document",
                    file_description: file.description,
                    file_type: file.file.type.split("/")[1],
                    file_name: file.file.name,
                    file_size: file.file.size,
                    flag: file.flag,
                    user_id: localStorage.getItem('username'),
                    issue_id: required_id,
                };
                processedFiles.push(processedFile);
                if (processedFiles.length === files.length) {
                    setUploadedFiles(processedFiles);
                }
            };
            reader.readAsDataURL(file.file);
        });
    };

    const [uploadedFilesIncident, setUploadedFilesIncident] = useState();

    const handleFilesSelectedIncidents = (files) => {
        const processedFiles = [];
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = function () {
                const base64FileContent = reader.result.split(",")[1];
                const required_id = selectedIncidentId
                const processedFile = {
                    file_content: base64FileContent,
                    object_type: "incident_document",
                    file_description: file.description,
                    file_type: file.file.type.split("/")[1],
                    file_name: file.file.name,

                    file_size: file.file.size,
                    flag: file.flag,
                    user_id: localStorage.getItem('username'),
                    incident_id: required_id,
                };
                processedFiles.push(processedFile);
                if (processedFiles.length === files.length) {
                    setUploadedFilesIncident(processedFiles);
                }
            };
            reader.readAsDataURL(file.file);
        });
    };


    const issuesDocumentUpload = useSelector(state => state.issuesDocumentUpload)

    const [documentsListArray, setDocumentListArray] = useState([])
    const handleDocumentUpload = (index) => {
        dispatch(handleDocumentLoaderTrue())
        if (tabType === "issues") {

            dispatch(uploadIssueDocuments(
                {
                    files: [uploadedFiles[index]]
                }
                , "issue_id"
            ))
        }
        else {
            dispatch(uploadIssueDocuments(
                {
                    files: [uploadedFilesIncident[index]]
                }, "incident_id"
            ))
        }
    }

    const handleErrorFromDocument = (value) => {
        setAlertShow(true)
        setAlertType('error')
        setAlertMessage('Error')
        setAlertValue(value)
        setAlertButtons([
            {
                name: 'Close', action: () => {
                    setAlertShow(false)
                }
            },
        ])
    }

    const [incidentReportedBy, setIncidentReportedBy] = useState("");
    const [isIncidentReportedByValid, setIsIncidentReportedByValid] = useState(true)

    const handleIncidentReportedByChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIncidentReportedBy(value)
        if (value.length < 3 || value.length > 200) {
            setIsIncidentReportedByValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIncidentReportedByValid(true)
        }
    }

    const [incidentDate, setIncidentDate] = useState("");

    const handleIncidentDateChange = (e) => {
        setIncidentDate(e.format("YYYY-MM-DD"))
    }

    const [incidentTime, setIncidentTime] = useState("");
    const [isIncidentTimeValid, setIsIncidentTimeValid] = useState(true)

    const handleIncidentTimeChange = (e) => {
        setIncidentTime(e.format("HH:mm:ss"))
    }

    const [incidentType, setIncidentType] = useState("");
    const [isIncidentTypeValid, setIsIncidentTypeValid] = useState(true)

    const handleIncidentTypeChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIncidentType(value)
        if (value.length < 3 || value.length > 200) {
            setIsIncidentTypeValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIncidentTypeValid(true)

        }
    }



    const [incidentStatus, setIncidentStatus] = useState("pending");
    const [isIncidentStatusValid, setIsIncidentStatusValid] = useState(true)

    const handleIncidentStatusChange = (e) => {
        setIncidentStatus(e.target.value)
    }

    const [incidentDescription, setIncidentDescription] = useState("");
    const [isIncidentDescriptionValid, setIsIncidentDescriptionValid] = useState(true)

    const handleIncidentDescriptionChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setIncidentDescription(value)
        if (value.length < 3) {
            setIsIncidentDescriptionValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsIncidentDescriptionValid(true)
        }
    }


    const [incidentRootCauseAnalysis, setIncidentRootCauseAnalysis] = useState("");
    const [isIncidentRootCauseAnalysisValid, setIsIncidentRootCauseAnalysisValid] = useState(true)

    const handleIncidentRootCauseAnalysisChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setIncidentRootCauseAnalysis(value)
        if (value.length < 3) {
            setIsIncidentRootCauseAnalysisValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsIncidentRootCauseAnalysisValid(true)
        }
    }

    const [incidentImmediateActionTaken, setIncidentImmediateActionTaken] = useState("");
    const [isIncidentImmediateActionTakenValid, setIsIncidentImmediateActionTakenValid] = useState(true)

    const handleIncidentImmediateActionTakenChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setIncidentImmediateActionTaken(value)
        if (value.length < 3) {
            setIsIncidentImmediateActionTakenValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsIncidentImmediateActionTakenValid(true)
        }
    }

    const [incidentCorrectiveActionTaken, setIncidentCorrectiveActionTaken] = useState("");
    const [isIncidentCorrectiveActionTakenValid, setIsIncidentCorrectiveActionTakenValid] = useState(true)

    const handleIncidentCorrectiveActionTakenChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setIncidentCorrectiveActionTaken(value)
        if (value.length < 3) {
            setIsIncidentCorrectiveActionTakenValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsIncidentCorrectiveActionTakenValid(true)
        }
    }

    const [incidentPreventiveActionTaken, setIncidentPreventiveActionTaken] = useState("");
    const [isIncidentPreventiveActionTakenValid, setIsIncidentPreventiveActionTakenValid] = useState(true)

    const handleIncidentPreventiveActionTakenChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setIncidentPreventiveActionTaken(value)
        if (value.length < 3) {
            setIsIncidentPreventiveActionTakenValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsIncidentPreventiveActionTakenValid(true)
        }
    }

    const [incidentComments, setIncidentComments] = useState("");
    const [isIncidentCommentsValid, setIsIncidentCommentsValid] = useState(true)

    const handleIncidentCommentsChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setIncidentComments(value)
        if (value.length < 3) {
            setIsIncidentCommentsValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsIncidentCommentsValid(true)
        }
    }

    const [incidentClosureBy, setIncidentClosureBy] = useState("");
    const [isIncidentClosureByValid, setIsIncidentClosureByValid] = useState(true)

    const handleIncidentClosureByChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIncidentClosureBy(value)
        if (value.length < 3 || value.length > 200) {
            setIsIncidentClosureByValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIncidentClosureByValid(true)
        }
    }

    const handleClearIncidentValidations = () => {
        setIsIncidentReportedByValid(true)
        setIsIncidentTimeValid(true)
        setIsIncidentTypeValid(true)
        setIsIncidentStatusValid(true)
        setIsIncidentDescriptionValid(true)
        setIsIncidentRootCauseAnalysisValid(true)
        setIsIncidentImmediateActionTakenValid(true)
        setIsIncidentCorrectiveActionTakenValid(true)
        setIsIncidentPreventiveActionTakenValid(true)
        setIsIncidentCommentsValid(true)
        setIsIncidentClosureByValid(true)
        setIsIncidentClosurePreparedByValid(true)
        setIsIncidentClosureReviewedByValid(true)

    }

    const handleSaveIncidentClicked = () => {
        setIsLoading(true)
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);
        setIssueIncidentStatus(incidentStatus);
        const statusValue = incidentStatus

        const data = {
            facility_id: selectedFacilityId,
            facility_name: selectedFacilityName,
            incident_reported_by: incidentReportedBy,
            request_raised_on: incidentDate,
            incident_time: incidentTime,
            issue_type: incidentType,
            status: incidentStatus,
            description_of_incident: incidentDescription,
            root_cause_analysis: incidentRootCauseAnalysis,
            immediate_action: incidentImmediateActionTaken,
            corrective_action: incidentCorrectiveActionTaken,
            preventive_action: incidentPreventiveActionTaken,
            comments: incidentComments,
            closure_done_by: incidentClosureBy,
            date_and_time_closure: incidentClosureDate + " " + incidentClosureTime,
            closure_prepared_by: incidentClosurePreparedBy,
            closure_reviewed_by: incidentClosureReviewedBy,
            customer_name: incidentCustomerName,
            customer_id: incidentCustomerId,
            billing_entity: selectedOurCompany,
            billing_entity_name: selectedOurCompanyName,

        }

        axios.post(base_url + "facilities/incidents", data)
            .then((res) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue("Incident added successfully")
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            setEditClicked(false)
                            setCurrentPage(1)
                            setIncidentReportedBy("")
                            setIncidentDate("")
                            setIncidentTime("")
                            setIncidentType("")
                            setIncidentStatus("pending")
                            setIncidentDescription("")
                            setIncidentRootCauseAnalysis("")
                            setIncidentImmediateActionTaken("")
                            setIncidentCorrectiveActionTaken("")
                            setIncidentPreventiveActionTaken("")
                            setIncidentComments("")
                            setIncidentClosureBy("")
                            setIncidentClosureDate("")
                            setIncidentClosurePreparedBy("")
                            setIncidentClosureReviewedBy("")
                            setIncidentClosureTime("")
                            setIncidentCustomerName("")
                            setIncidentCustomerId("")
                            setSelectedOurCompany("")
                            setSelectedOurCompanyName("")
                            setSelectedIncidentCustomer("")
                            handleClearIncidentValidations()

                            dispatch(getAllIssues(
                                {
                                    search_text: "",
                                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                                    page_number: 1,
                                    filter_condition: {
                                        facility_id: selectedFacilityId,
                                        status: statusValue
                                    }
                                }
                            ))

                            dispatch(getAllIncidents(
                                {
                                    search_text: "",
                                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                                    page_number: 1,
                                    filter_condition: {
                                        facility_id: selectedFacilityId,
                                        status: statusValue
                                    }
                                }
                            ))
                            setIsLoading(false)


                        }
                    },
                ])
            })
            .catch((err) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(err?.response?.data.message)
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                        }
                    },
                ])
            })

    }

    const handleUpdateIncidentClicked = () => {
        setIsLoading(true)
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);
        setIssueIncidentStatus(incidentStatus);
        const statusValue = incidentStatus

        const data = {
            incident_id: incidentId,
            facility_id: selectedFacilityId,
            facility_name: selectedFacilityName,
            incident_reported_by: incidentReportedBy,
            request_raised_on: incidentDate,
            incident_time: incidentTime,
            issue_type: incidentType,
            status: incidentStatus,
            description_of_incident: incidentDescription,
            root_cause_analysis: incidentRootCauseAnalysis,
            immediate_action: incidentImmediateActionTaken,
            corrective_action: incidentCorrectiveActionTaken,
            preventive_action: incidentPreventiveActionTaken,
            comments: incidentComments,
            closure_done_by: incidentClosureBy,
            date_and_time_closure: incidentClosureDate + " " + incidentClosureTime,
            closure_prepared_by: incidentClosurePreparedBy,
            closure_reviewed_by: incidentClosureReviewedBy,
            customer_name: incidentCustomerName,
            customer_id: incidentCustomerId,
            billing_entity: selectedOurCompany,
            billing_entity_name: selectedOurCompanyName,

        }

        axios.put(base_url + "facilities/incidents", data)
            .then((res) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue("Incident updated successfully")
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            setEditClicked(false)
                            setCurrentPage(1)
                            setIncidentReportedBy("")
                            setIncidentDate("")
                            setIncidentTime("")
                            setIncidentType("")
                            setIncidentStatus("pending")
                            setIncidentDescription("")
                            setIncidentRootCauseAnalysis("")
                            setIncidentImmediateActionTaken("")
                            setIncidentCorrectiveActionTaken("")
                            setIncidentPreventiveActionTaken("")
                            setIncidentComments("")
                            setIncidentClosureBy("")
                            setIncidentClosureDate("")
                            setIncidentClosurePreparedBy("")
                            setIncidentClosureReviewedBy("")
                            setIncidentClosureTime("")
                            setIncidentCustomerName("")
                            setIncidentCustomerId("")
                            handleClearIncidentValidations()
                            setSelectedOurCompany("")
                            setSelectedOurCompanyName("")
                            setSelectedIncidentCustomer("")
                            dispatch(getAllIssues(
                                {
                                    search_text: "",
                                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                                    page_number: 1,
                                    filter_condition: {
                                        facility_id: selectedFacilityId,
                                        status: statusValue
                                    }
                                }
                            ))

                            dispatch(getAllIncidents(
                                {
                                    search_text: "",
                                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                                    page_number: 1,
                                    filter_condition: {
                                        facility_id: selectedFacilityId,
                                        status: statusValue
                                    }
                                }
                            ))
                            setIsLoading(false)


                        }
                    },
                ])
            })
            .catch((err) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(err?.response?.data.message)
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                        }
                    },
                ])
            })

    }

    const handleCancelIncidentClicked = () => {
        if (viewClicked) {
            setCurrentPage(1)
            setIncidentReportedBy("")
            setIncidentDate("")
            setIncidentTime("")
            setIncidentType("")
            setIncidentStatus("pending")
            setIncidentDescription("")
            setIncidentRootCauseAnalysis("")
            setIncidentImmediateActionTaken("")
            setIncidentCorrectiveActionTaken("")
            setIncidentPreventiveActionTaken("")
            setIncidentComments("")
            setViewClicked(false)
            setEditClicked(false)
            setIncidentId("")
            setSelectedIncidentId("")
            setDocumentListArray([])
            setIncidentClosureBy("")
            setIncidentClosureDate("")
            setIncidentClosurePreparedBy("")
            setIncidentClosureReviewedBy("")
            setIncidentClosureTime("")
            setIncidentCustomerName("")
            setIncidentCustomerId("")
            handleClearIncidentValidations()
            setSelectedIncidentCustomer("")
            setCurrentPage(1)
        }
        else {
            setAlertShow(true)
            setAlertType('warning')
            setAlertMessage('Warning')
            setAlertValue("Are you sure you want to cancel? The changes you made will not be saved.")
            setAlertButtons([
                {
                    name: 'Yes', action: () => {
                        setAlertShow(false)
                        setCurrentPage(1)
                        setIncidentReportedBy("")
                        setIncidentDate("")
                        setIncidentTime("")
                        setIncidentType("")
                        setIncidentStatus("pending")
                        setIncidentDescription("")
                        setIncidentRootCauseAnalysis("")
                        setIncidentImmediateActionTaken("")
                        setIncidentCorrectiveActionTaken("")
                        setIncidentPreventiveActionTaken("")
                        setIncidentComments("")
                        setViewClicked(false)
                        setEditClicked(false)
                        setIncidentId("")
                        setSelectedIncidentId("")
                        setDocumentListArray([])
                        setIncidentClosureBy("")
                        setIncidentClosureDate("")
                        setIncidentClosurePreparedBy("")
                        setIncidentClosureReviewedBy("")
                        setIncidentClosureTime("")
                        setIncidentCustomerName("")
                        setIncidentCustomerId("")
                        handleClearIncidentValidations()
                        setSelectedIncidentCustomer("")
                        setCurrentPage(1)
                    }
                },
                {
                    name: 'No', action: () => {
                        setAlertShow(false)
                    }
                },
            ])
        }

    }

    const [incidentClosurePreparedBy, setIncidentClosurePreparedBy] = useState("");
    const [isIncidentClosurePreparedByValid, setIsIncidentClosurePreparedByValid] = useState(true)

    const handleIncidentClosurePreparedByChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIncidentClosurePreparedBy(value)
        if (value.length < 3 || value.length > 200) {
            setIsIncidentClosurePreparedByValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIncidentClosurePreparedByValid(true)
        }
    }

    const [incidentClosureReviewedBy, setIncidentClosureReviewedBy] = useState("");
    const [isIncidentClosureReviewedByValid, setIsIncidentClosureReviewedByValid] = useState(true)

    const handleIncidentClosureReviewedByChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIncidentClosureReviewedBy(value)
        if (value.length < 3 || value.length > 200) {
            setIsIncidentClosureReviewedByValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIncidentClosureReviewedByValid(true)
        }
    }

    const [incidentClosureDate, setIncidentClosureDate] = useState(dayjs().format("YYYY-MM-DD"));

    const handleIncidentClosureDateChange = (e) => {
        setIncidentClosureDate(e.format("YYYY-MM-DD"))
    }

    const [incidentClosureTime, setIncidentClosureTime] = useState("");

    const handleIncidentClosureTimeChange = (e) => {
        setIncidentClosureTime(e.format('HH:mm:ss'))
    }

    const [issueClosurePreparedBy, setIssueClosurePreparedBy] = useState("");
    const [isIssueClosurePreparedByValid, setIsIssueClosurePreparedByValid] = useState(true)

    const handleIssueClosurePreparedByChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIssueClosurePreparedBy(value)
        if (value.length < 3 || value.length > 200) {
            setIsIssueClosurePreparedByValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIssueClosurePreparedByValid(true)
        }
    }

    const [issueClosureReviewedBy, setIssueClosureReviewedBy] = useState("");
    const [isIssueClosureReviewedByValid, setIsIssueClosureReviewedByValid] = useState(true)

    const handleIssueClosureReviewedByChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIssueClosureReviewedBy(value)
        if (value.length < 3 || value.length > 200) {
            setIsIssueClosureReviewedByValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIssueClosureReviewedByValid(true)
        }
    }


    const [issueClosureDate, setIssueClosureDate] = useState(null);

    const handleIssueClosureDateChange = (e) => {
        setIssueClosureDate(e.format("YYYY-MM-DD"))
    }

    const [issueClosureTime, setIssueClosureTime] = useState("");

    const handleIssueClosureTimeChange = (e) => {
        setIssueClosureTime(e.format('HH:mm:ss'))
    }

    const [issueTime, setIssueTime] = useState("");

    const handleIssueTimeChange = (e) => {
        setIssueTime(e.format('HH:mm:ss'))
    }

    const handleIssueCustomerNameChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIssueCustomerName(value)
        if (value.length < 3 || value.length > 200) {
            setIsIssueCustomerNameValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIssueCustomerNameValid(true)
        }
    }

    const handleIncidentCustomerNameChange = (e) => {
        const value = eleminateSpecialCharactersAtStartOfInputField(eleminateSpacesAtStartOfInputField(e.target.value))
        setIncidentCustomerName(value)
        if (value.length < 3 || value.length > 200) {
            setIsIncidentCustomerNameValid(false)
        }
        if (value === "" || (value.length >= 3 && value.length <= 200)) {
            setIsIncidentCustomerNameValid(true)
        }
    }

    const [rootCauseAnalysis, setRootCauseAnalysis] = useState("");
    const [isRootCauseAnalysisValid, setIsRootCauseAnalysisValid] = useState(true)

    const handleRootCauseAnalysisChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setRootCauseAnalysis(value)
        if (value.length < 3) {
            setIsRootCauseAnalysisValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsRootCauseAnalysisValid(true)
        }
    }

    const [correctiveActionTaken, setCorrectiveActionTaken] = useState("");
    const [isCorrectiveActionTakenValid, setIsCorrectiveActionTakenValid] = useState(true)

    const handleCorrectiveActionTakenChange = (e) => {
        const value = eleminateSpacesAtStartOfInputField(e.target.value)
        setCorrectiveActionTaken(value)
        if (value.length < 3) {
            setIsCorrectiveActionTakenValid(false)
        }
        if (value === "" || value.length > 3) {
            setIsCorrectiveActionTakenValid(true)
        }
    }

    function base64ToArrayBuffer(base64) {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    const handleDownloadIssueOrIncident = (data) => {
        setIsLoading(true);
        let body = {}
        let resource = ""
        if (tabType === "issues") {
            resource = "pdfgenerator/generateissuepdf"
        }
        else {
            resource = "pdfgenerator/generateincidentpdf"
        }

        axios.post(base_url + resource, data)
            .then((response) => {
                const url = window.URL.createObjectURL(
                    new Blob([base64ToArrayBuffer(response.data.data.pdf)], {
                        type: "application/pdf",
                    })
                );
                const link = document.createElement("a");
                link.href = url;
                const naming = data.issue_id ? "Issue-Report" : "Incident-Report"
                link.setAttribute("download", `${naming}-${data.request_no}.pdf`);
                document.body.appendChild(link);
                link.click();

                setIsLoading(false)
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue(<>
                    <p>
                        {`${naming} downloaded successfully`}
                    </p>
                </>)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
            })
            .catch((err) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(err?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
            })

    }

    const [selectedOurCompany, setSelectedOurCompany] = useState("");
    const [selectedOurCompanyName, setSelectedOurCompanyName] = useState("");

    const handleOurCompanyChange = (e) => {
        setSelectedOurCompany(e.target.value)
        const selectedCompany = billingEntities?.find((company) => company.partner_company_id === e.target.value);
        setSelectedOurCompanyName(selectedCompany?.company_name);
    }



    const getGroupNameOriginal = (val) => {
        switch (val) {
            case "Commercial Head":
                return COMMERCIAL_HEAD_GROUP;
            case "Technician":
                return TECHNICIAN_GROUP;
            case "Finance Manager":
                return FINANCE_MANAGER_GROUP;
            case "Facility Manager":
                return FACILITY_MANAGER_GROUP;
            case "CEO":
                return CEO_GROUP;
            case "Customer":
                return PORTOS_CUSTOMER_GROUP
            default:
                return "";
        }
    }
    const isManage = ACLS[getGroupNameOriginal(localStorage.getItem('group'))].find(obj => obj.ROUTE === "/issuesAndIncidents" && obj.PERMISSIONS?.includes("MANAGE"));





    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            {
                contractApiLoader || isLoading ?
                    <Loader />
                    :
                    null
            }


            <AlertPopUp alertShow={alertShow} alertType={alertType} alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
            {currentPage === 1 &&
                <div className='meter_reports_container'>
                    <div className='d-flex justify-content-between align-items-center flex-wrap'>
                        <div className='d-flex align-items-center gap-3 mb-3'>
                            <h3 className="invoice-heading" >Issues and Incidents</h3>
                        </div>
                        <div className='d-flex align-items-center gap-3 mb-3'>

                            {isManage && <button className='invoice_btn' onClick={() => {
                                if (tabType === "issues") {
                                    setCurrentPage(2)
                                }
                                else {
                                    setCurrentPage(3)
                                }
                            }}
                                style={{ color: "white" }}>
                                <span className='generate_invoice'>
                                    <MdPersonAddAlt1 size={20} className="icon-newContact" style={{ marginRight: "10px" }} alt="+" />
                                    {`Add new ${tabType}`}</span><span className='generate'>
                                    <MdPersonAddAlt1 size={20} className="icon-newContact" style={{ marginRight: "10px" }} alt="+" />Add</span></button>}

                        </div>
                    </div>
                    <div className='fm-invoice-con-filters' style={{ zIndex: 100, marginBottom: '10px' }}>
                        <div style={{ width: '280px' }} className="fin_man_billing_period">
                            <p style={{ marginBottom: '-15px' }}>Facility:&nbsp;</p>
                            <SearchableDropdown
                                style={{ zIndex: 100 }}
                                // className = "searchable-dropdown2"
                                options={facilityList ? facilityList : []} //facilityList is the array of facilities
                                selectedOption={selectedfacility}
                                noOptionsAvailable="Facility unavailable"
                                onChange={(e) => {
                                    setSelectedFacility(e.value)
                                    const selectedFacility = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                    setSelectedFacilityName(selectedFacility?.name);
                                    setSelectedCityName(selectedFacility?.city);
                                    setSelectedFacilityId(selectedFacility?.facility_id);
                                    setIsFacilitySelected(true);
                                }}

                                placeholder="Select Facility"
                                isDisabled={false}
                            />
                        </div>
                        <div style={{ width: '140px' }} className="fin_man_billing_period">
                            <p style={{ marginBottom: '5px' }}>Status&nbsp;</p>
                            <select
                                value={issueIncidentStatus}
                                onChange={(e) => {
                                    setIssueIncidentStatus(e.target.value);
                                }}
                                className="invoice-select-date"
                                style={{ width: "100%", height: "2.5rem" }}
                            >
                                <option value="pending">Pending</option>
                                <option value="completed">Completed</option>
                                { }
                            </select>
                        </div>


                        <div className='d-flex align-items-center gap-3 mb-3'>
                            <div className='fin_man_meter_search_bar_container'>
                                <input style={{ marginTop: '20px', height: '2.5rem' }}
                                    type='search'
                                    placeholder='Search'
                                    value={searchText}
                                    onChange={(e) => searchFunc(e.target.value)}
                                    className='fin_man_meter_search_bar' />
                                <GoSearch

                                    style={{ marginTop: '17px' }} className='fin_man_meter_search_bar_icon C-pointer' />
                            </div>

                        </div>
                        <div className='d-flex align-items-center gap-3'>
                            <button className="invoice_btn primary-button" style={{ marginTop: '4px', color: 'white', height: '20px !important' }} onClick={() => {
                                applyFilterClicked()
                            }}>Apply</button>
                            <button className="invoice_btn secondary-button" style={{ marginTop: '4px', color: 'white', height: '20px !important' }}
                                onClick={() => {
                                    clearFilterClicked()
                                }}
                            >Clear</button>

                        </div>

                    </div>
                    <Stack direction="horizontal" className="mt-1 invoice-type-div" gap={6}>
                        {typesOfTabs.map((i, index) => {
                            return (
                                <div key={index} className="invoice-type-card" onClick={() => { onchangeTabType(i.id) }}>
                                    <p className={i.id === tabType ? "selected-invoice-type C-pointer" : "C-pointer"}>{i.name}</p>
                                </div>
                            )
                        })
                        }
                    </Stack>


                    {
                        tabType === "issues" ?
                            <>
                                <div className='table_container_commercial_head'>
                                    <TableComponent
                                        headers={[{
                                            name: "Sequence No",
                                            type: "text",
                                            key: "sequence_number",
                                            sort: true
                                        },
                                        {
                                            name: "Company Name",
                                            type: "text",
                                            key: "customer_name",
                                            sort: true
                                        }, {
                                            name: "Reported By",
                                            type: "text",
                                            key: "issue_reported_by",
                                            sort: true
                                        }, {
                                            name: "Issue Type",
                                            type: "text",
                                            key: "issue_type",
                                            sort: true,
                                            formatNumberWithComas: true
                                        },
                                        {
                                            name: "Issue Date",
                                            type: "date",
                                            key: "issue_date",
                                            sort: true
                                        },
                                        {
                                            name: "Issue Time",
                                            type: "time",
                                            key: "issue_time",
                                            sort: true
                                        },

                                        {
                                            name: "Status",
                                            type: "text",
                                            key: "status",
                                            sort: true,
                                            formatNumberWithComas: true
                                        },

                                        {
                                            name: "Updated By",
                                            type: "text",
                                            key: "created_by",
                                            sort: true
                                        }, {
                                            name: "Last Updated At",
                                            type: "time_stamp",
                                            key: "updated_at",
                                            sort: true
                                        },
                                        {
                                            name: "Action",
                                            type: "button",
                                            buttons: isManage ? [{
                                                name: "View",
                                                icon: "./images/icons/View.png",
                                                disable: handleEnable,
                                                action: (data) => handleViewActionClicked(data)
                                            },
                                            {
                                                name: "Edit",
                                                icon: "./images/icons/Edit.svg",
                                                disable: handleEnable,
                                                action: (data) => handleEditActionClicked(data)

                                            },
                                            {
                                                name: "Download",
                                                icon: "./images/icons/Download.svg",
                                                disable: (data) => data.status !== "completed",
                                                hidden: (data) => data.status !== "completed",
                                                action: (data) => { handleDownloadIssueOrIncident(data) }
                                            }
                                            ] : [
                                                {
                                                    name: "View",
                                                    icon: "./images/icons/View.png",
                                                    disable: handleEnable,
                                                    action: (data) => handleViewActionClicked(data)
                                                }, {
                                                    name: "Download",
                                                    icon: "./images/icons/Download.svg",
                                                    disable: (data) => data.status !== "completed",
                                                    hidden: (data) => data.status !== "completed",
                                                    action: (data) => handleDownloadIssueOrIncident(data)
                                                }
                                            ]
                                        },
                                        ]}

                                        data={allIssues}
                                    />
                                </div>
                                <Pagination
                                    handledPaginationNextClicked={handledPaginationNextClickedIssues}
                                    handledPaginationPrevClicked={handledPaginationPrevClickedIssues}
                                    isApplyClicked
                                    totalRecords={totalRecordsIssues}
                                    recordsPerPage={RECORDS_PER_PAGE_METER_MASTER}
                                    currentPaginationPage={currentPaginationPageIssues}
                                />
                            </>
                            :
                            <>
                                <div className='table_container_commercial_head'>
                                    <TableComponent
                                        headers={[
                                            {
                                                name: "Sequence No",
                                                type: "text",
                                                key: "sequence_number",
                                                sort: true
                                            },
                                            {
                                                name: "Company Name",
                                                type: "text",
                                                key: "customer_name",
                                                sort: true,
                                            }, {
                                                name: "Incident Type",
                                                type: "text",
                                                key: "issue_type",
                                                sort: true,
                                                formatNumberWithComas: true
                                            }, {
                                                name: "Reported By",
                                                type: "text",
                                                key: "incident_reported_by",
                                                sort: true
                                            }, {
                                                name: "Incident Date",
                                                type: "date",
                                                key: "request_raised_on",
                                                sort: true
                                            },
                                            {
                                                name: "Incident Time",
                                                type: "time",
                                                key: "incident_time",
                                                sort: true
                                            },
                                            {
                                                name: "Status",
                                                type: "text",
                                                key: "status",
                                                sort: true,
                                                formatNumberWithComas: true
                                            },
                                            {
                                                name: "Updated By",
                                                type: "text",
                                                key: "updated_by",
                                                sort: true
                                            },
                                            {
                                                name: "Last Updated At",
                                                type: "time_stamp",
                                                key: "updated_at",
                                                sort: true
                                            }, {
                                                name: "Action",
                                                type: "button",
                                                buttons: isManage ? [{
                                                    name: "View",
                                                    icon: "./images/icons/View.png",
                                                    disable: handleEnable,
                                                    action: (data) => handleViewActionClicked(data)
                                                },
                                                {
                                                    name: "Edit",
                                                    icon: "./images/icons/Edit.svg",
                                                    disable: handleEnable,
                                                    action: (data) => handleEditActionClicked(data)

                                                },
                                                {
                                                    name: "Download",
                                                    icon: "./images/icons/Download.svg",
                                                    disable: (data) => data.status !== "completed",
                                                    hidden: (data) => data.status !== "completed",
                                                    action: (data) => { handleDownloadIssueOrIncident(data) }
                                                }
                                                ] : [
                                                    {
                                                        name: "View",
                                                        icon: "./images/icons/View.png",
                                                        disable: handleEnable,
                                                        action: (data) => handleViewActionClicked(data)
                                                    }, {
                                                        name: "Download",
                                                        icon: "./images/icons/Download.svg",
                                                        disable: (data) => data.status !== "completed",
                                                        hidden: (data) => data.status !== "completed",
                                                        action: (data) => { handleDownloadIssueOrIncident(data) }
                                                    }
                                                ]
                                            },
                                        ]}

                                        data={allIncidents}
                                    />
                                </div>
                                <Pagination
                                    id="incidents"
                                    handledPaginationNextClicked={handledPaginationNextClickedIncidents}
                                    handledPaginationPrevClicked={handledPaginationPrevClickedIncidents}
                                    isApplyClicked
                                    totalRecords={totalRecordsIncidents}
                                    recordsPerPage={RECORDS_PER_PAGE_METER_MASTER}
                                    currentPaginationPage={currentPaginationPageIncidents}
                                />
                            </>
                    }



                </div>
            }
            {
                currentPage === 2 &&
                <div className="newPaymentContainer">
                    <div style={{ display: "flex", flexDirection: "column", margin: '10px', marginBottom: "100px" }}>
                        <div>
                            <h2>Issue Details</h2>
                        </div>

                        <div style={{ marginTop: "20px" }}>
                            <Tabs
                                activeKey={activeTab}
                                onSelect={(k) => setActiveTab(k)}
                                id="uncontrolled-tab-example"
                                className="mb-0"
                            >
                                <Tab eventKey="1" title="Issue Details"
                                    className="assetTabs"
                                // disabled={!viewClicked && !editClicked}
                                >
                                    <div className="infoBody">
                                        <div>
                                            <div className="infoBodyInputs">
                                                <div className="responsiveInputSection">
                                                    <div>
                                                        <p style={{ marginBottom: "-18px" }}>Facility:&nbsp; <span style={{ color: "red" }}>*</span></p>
                                                        <SearchableDropdown
                                                            style={{ zIndex: 100 }}
                                                            className="searchable-dropdown2"
                                                            options={facilityList ? facilityList : []} //facilityList is the array of facilities
                                                            selectedOption={selectedfacility}
                                                            noOptionsAvailable="Facility unavailable"
                                                            onChange={(e) => {
                                                                setSelectedFacility(e.value)
                                                                const selectedFacility = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                                                setSelectedFacilityName(selectedFacility?.name);
                                                                setSelectedCityName(selectedFacility?.city);
                                                                setSelectedFacilityId(selectedFacility?.facility_id);
                                                                setIsFacilitySelected(true);
                                                            }}

                                                            placeholder="Select Facility"
                                                            isDisabled={viewClicked}
                                                        />
                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Issue Reported By <span style={{ color: "red" }}>*</span></label>
                                                        <input type='text'
                                                            value={issueReportedBy}
                                                            disabled={viewClicked}
                                                            onChange={handleIssueReportedByChange}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIssueReportedByValid && "Min of 3 letters max of 200"}</span>

                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <label className='add-facility-modal-label'
                                                        >Issue Date <span style={{ color: "red" }}>*</span></label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label=""
                                                                disabled={viewClicked}
                                                                value={dayjs(issueDate)}
                                                                className="form-control responsive-add-facility-input-fields"
                                                                views={['day', 'month', 'year']}
                                                                format={localStorage.getItem("date_format")}
                                                                minDate={dayjs(new Date(new Date().setMonth(new Date().getMonth() - 1)))}  // ✅ Set min date = 1 month ago
                                                                maxDate={dayjs(new Date())}  // ✅ Max date = today
                                                                onChange={(newValue) => {
                                                                    handleIssueDateChange(newValue);
                                                                }}
                                                                sx={{
                                                                    '.MuiInputBase-root': {
                                                                        height: '40px',
                                                                        maxWidth: "250px",
                                                                        backgroundColor: 'white',
                                                                        borderRadius: '6px',
                                                                        fontSize: '14px',
                                                                    },
                                                                }}
                                                            // slotProps={{
                                                            //     textField: {
                                                            //     InputProps: {
                                                            //         readOnly: true,
                                                            //     },
                                                            //     onKeyDown: (e) => e.preventDefault(),
                                                            //     },
                                                            // }}
                                                            />
                                                        </LocalizationProvider>

                                                    </div>



                                                </div>
                                                <div className="responsiveInputSection">

                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <label className='add-facility-modal-label'
                                                        >Issue Time <span style={{ color: "red" }}>*</span></label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <TimePicker
                                                                disabled={viewClicked}
                                                                value={dayjs(issueTime, 'HH:mm:ss')}
                                                                className='form-control responsive-add-facility-input-fields'
                                                                onChange={(newValue) => handleIssueTimeChange(newValue)}
                                                                sx={{
                                                                    '.MuiInputBase-root': {
                                                                        height: '40px', // Adjust height
                                                                        maxWidth: "250px",
                                                                        backgroundColor: 'white', // Set background to white
                                                                        borderRadius: '6px', // Optional: Rounded corners
                                                                        fontSize: '14px', // Optional: Adjust text size
                                                                    },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>

                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Issue Type <span style={{ color: "red" }}>*</span></label>
                                                        <input type='text'
                                                            value={issueType}
                                                            disabled={viewClicked}
                                                            onChange={handleIssueTypeChange}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIssueTypeValid && "Min of 3 letters max of 200"}</span>
                                                    </div>

                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Issue Status <span style={{ color: "red" }}>*</span></label>
                                                        <select
                                                            disabled={viewClicked}
                                                            value={issueStatus}
                                                            onChange={(e) => {
                                                                handleIssueStatusChange(e);
                                                            }}
                                                            className="form-select responsive-add-facility-input-fields invoice-select-date"
                                                            style={{ width: "100%", height: "2.5rem", margin: "0px" }}
                                                        >
                                                            <option value="pending">Pending</option>
                                                            <option value="completed">Completed</option>
                                                            { }
                                                        </select>

                                                    </div>


                                                </div>
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'>Customer Name </label>
                                                        <select
                                                            style={{ margin: "0px" }}
                                                            className="form-select responsive-add-facility-input-fields invoice-select-date"
                                                            disabled={viewClicked}
                                                            value={JSON.stringify({ customer_id: issueCustomerId, company_name: issueCustomerName })}
                                                            onChange={(e) => {
                                                                const selected = JSON.parse(e.target.value);
                                                                setIssueCustomerId(selected.customer_id);
                                                                setIssueCustomerName(selected.company_name);
                                                            }}
                                                        >
                                                            <option hidden>Select a Customer</option>
                                                            {companyList?.map((company, index) => (
                                                                <option key={index} value={JSON.stringify({ customer_id: company?.customer_id, company_name: company?.company_name })}>{company?.company_name}</option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Our Company {<span style={{ color: "red" }}>*</span>}</label>
                                                        <select
                                                            disabled={viewClicked}
                                                            value={selectedOurCompany}
                                                            onChange={handleOurCompanyChange}
                                                            className='form-select '>
                                                            <option value="" hidden>Select Our Company</option>
                                                            {
                                                                billingEntities?.map((company) => (
                                                                    <option key={company.partner_company_id} value={company.partner_company_id}>
                                                                        {company.company_name}
                                                                    </option>
                                                                ))
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSectio" >
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <div>
                                                            {/* Billing Entity Summary */}
                                                            {selectedOurCompany && (() => {
                                                                const selectedEntity = billingEntities?.find(
                                                                    entity => entity.partner_company_id === selectedOurCompany
                                                                );

                                                                if (!selectedEntity) return null;

                                                                return (
                                                                    <div style={{
                                                                        marginTop: '10px',
                                                                        padding: '15px',
                                                                        backgroundColor: '#f8f9fa',
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #dee2e6',
                                                                        width: '88vw'
                                                                    }}>
                                                                        <div style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: '600',
                                                                            marginBottom: '10px',
                                                                            color: '#495057'
                                                                        }}>
                                                                            Company Summary
                                                                        </div>

                                                                        <div style={{ fontSize: '13px', color: '#6c757d' }}>
                                                                            <div
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    flexWrap: 'wrap',
                                                                                    justifyContent: 'space-between',
                                                                                    // gap: '10px 20px', // row gap | column gap
                                                                                }}
                                                                            >


                                                                                <div >
                                                                                    <strong>GST Number:</strong> {selectedEntity.gst_number || 'N/A'}
                                                                                </div>

                                                                                <div >
                                                                                    <strong>PAN:</strong> {selectedEntity.pan_number || 'N/A'}
                                                                                </div>

                                                                                <div >
                                                                                    <strong>CIN:</strong> {selectedEntity.cin || 'N/A'}
                                                                                </div>
                                                                            </div>


                                                                            {selectedEntity.registered_address && (
                                                                                <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #dee2e6' }}>
                                                                                    <div style={{ fontWeight: '600', marginBottom: '6px' }}>Registered Address:</div>
                                                                                    <div style={{ lineHeight: '1.6' }}>
                                                                                        {selectedEntity.registered_address.door_number && `${selectedEntity.registered_address.door_number}, `}
                                                                                        {selectedEntity.registered_address.street_address_1 && selectedEntity.registered_address.street_address_1 !== "Street address- -NA-" && `${selectedEntity.registered_address.street_address_1}, `}
                                                                                        {selectedEntity.registered_address.street_address_2 && `${selectedEntity.registered_address.street_address_2}, `}
                                                                                        {selectedEntity.registered_address.city && `${selectedEntity.registered_address.city}, `}
                                                                                        {selectedEntity.registered_address.state && `${selectedEntity.registered_address.state} - `}
                                                                                        {selectedEntity.registered_address.postal_code && `${selectedEntity.registered_address.postal_code}, `}
                                                                                        {selectedEntity.registered_address.country}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>
                                                </div>


                                                <hr />

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Brief Description of the Issue</label>
                                                        <textarea className='form-control'
                                                            value={issueDescriptiion}
                                                            disabled={viewClicked}

                                                            onChange={handleIssueDescriptionChange}

                                                            placeholder='Description of the issue'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIssueDescriptionValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Root Cause Analysis</label>
                                                        <textarea className='form-control'
                                                            value={rootCauseAnalysis}
                                                            disabled={viewClicked}
                                                            onChange={handleRootCauseAnalysisChange}
                                                            placeholder="Please add root cause analysis"
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isRootCauseAnalysisValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Immediate Action Taken</label>
                                                        <textarea className='form-control'
                                                            value={immediateActionTaken}
                                                            disabled={viewClicked}
                                                            onChange={handleImmediateActionTakenChange}

                                                            placeholder='Please add the immediate action taken'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isImmediateActionTakenValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Corrective Action Taken</label>
                                                        <textarea className='form-control'
                                                            value={correctiveActionTaken}
                                                            disabled={viewClicked}
                                                            onChange={handleCorrectiveActionTakenChange}
                                                            placeholder='Please add the corrective action taken'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isCorrectiveActionTakenValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Preventive Action Taken</label>
                                                        <textarea className='form-control'
                                                            value={preventiveActionTaken}
                                                            disabled={viewClicked}

                                                            onChange={handlePreventiveActionTakenChange}

                                                            placeholder='Please add the preventive action taken'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isPreventiveActionTakenValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Comments</label>
                                                        <textarea className='form-control'
                                                            disabled={viewClicked}

                                                            value={comments}
                                                            onChange={handleCommentsChange}
                                                            placeholder='Please add your comment'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isPreventiveActionTakenValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        <hr></hr>
                                        {
                                            selectedIssueId &&
                                            <>
                                                <UploadComponent
                                                    onFilesSelected={handleFilesSelected}
                                                    uploadMethod="single"
                                                    viewMode={viewClicked}
                                                    uploadedFileData={documentsListArray}
                                                    uploadActionClicked={handleDocumentUpload}
                                                    // // deleteSpecificFileMain={confirmDeleteDocument}
                                                    maxNumberOfFiles={5}
                                                    handleErrorFromDocument={handleErrorFromDocument}
                                                    idType={"issues"}
                                                    acceptedFileTypes={".pdf, .jpeg, .jpg, .png"}
                                                />
                                                <hr></hr>

                                            </>


                                        }
                                        <div className="responsiveInputSection">
                                            <div >
                                                <label className='add-facility-modal-label'
                                                >Issue Closure By </label>
                                                <input type='text'
                                                    style={{ width: "280px" }}
                                                    value={issueClosureBy}
                                                    onChange={(e) => {
                                                        handleIssueClosureByChange(e)
                                                    }}
                                                    disabled={viewClicked}
                                                    className='form-control responsive-add-facility-input-fields' />
                                                <span style={{ color: "red", fontSize: "small" }}>{!isIssueClosureByValid && "Min of 3 and max of 200 letters required"}</span>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {issueStatus === 'completed' && (!issueClosureBy || issueClosureBy.length === 0) ? "Issue Closure By is required" : ""}
                                                </span>

                                            </div>

                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <label className='add-facility-modal-label'
                                                >Issue Closure Date</label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label=""
                                                        disabled={viewClicked}
                                                        value={dayjs(issueClosureDate)}
                                                        className='form-control responsive-add-facility-input-fields'
                                                        views={['day', 'month', 'year']}
                                                        format={localStorage.getItem("date_format")}
                                                        minDate={dayjs(issueDate)} // Set minimum selectable date
                                                        onChange={(newValue) => {
                                                            handleIssueClosureDateChange(newValue);
                                                        }
                                                        }
                                                        sx={{
                                                            '.MuiInputBase-root': {
                                                                height: '40px', // Adjust height
                                                                maxWidth: "250px",
                                                                backgroundColor: 'white', // Set background to white
                                                                borderRadius: '6px', // Optional: Rounded corners
                                                                fontSize: '14px', // Optional: Adjust text size
                                                            },
                                                        }}
                                                    // slotProps={{
                                                    //     textField: {
                                                    //         InputProps: {
                                                    //             readOnly: true, // Prevent typing in the input field
                                                    //         },
                                                    //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                                    //     },
                                                    // }}
                                                    />
                                                </LocalizationProvider>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {issueStatus === 'completed' && (!issueClosureDate || issueClosureDate.length === 0) ? "Issue Closure Date is required" : ""}
                                                </span>

                                            </div>

                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <label className='add-facility-modal-label'
                                                >Issue Closure Time </label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <TimePicker
                                                        // label="Controlled picker"
                                                        value={dayjs(issueClosureTime, 'HH:mm:ss')}
                                                        disabled={viewClicked}
                                                        className='form-control responsive-add-facility-input-fields'
                                                        onChange={(newValue) => handleIssueClosureTimeChange(newValue)}
                                                        sx={{
                                                            '.MuiInputBase-root': {
                                                                height: '40px', // Adjust height
                                                                maxWidth: "250px",
                                                                backgroundColor: 'white', // Set background to white
                                                                borderRadius: '6px', // Optional: Rounded corners
                                                                fontSize: '14px', // Optional: Adjust text size
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {issueStatus === 'completed' && (!issueClosureTime || issueClosureTime.length === 0) ? "Issue Closure Time is required" : ""}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="responsiveInputSection">
                                            <div >
                                                <label className='add-facility-modal-label'
                                                >Issue Closure Prepared By </label>
                                                <input type='text'
                                                    style={{ width: "280px" }}
                                                    value={issueClosurePreparedBy}
                                                    onChange={(e) => {
                                                        handleIssueClosurePreparedByChange(e)
                                                    }}
                                                    disabled={viewClicked}
                                                    className='form-control responsive-add-facility-input-fields' />
                                                <span style={{ color: "red", fontSize: "small" }}>{!isIssueClosurePreparedByValid && "Min of 3 and max of 200 letters required"}</span>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {issueStatus === 'completed' && (!issueClosurePreparedBy || issueClosurePreparedBy.length === 0) ? "Issue Closure Prepared By is required" : ""}
                                                </span>


                                            </div>

                                            <div >
                                                <label className='add-facility-modal-label'
                                                >Issue Closure Reviewed By </label>
                                                <input type='text'
                                                    style={{ width: "280px" }}
                                                    value={issueClosureReviewedBy}
                                                    onChange={(e) => {
                                                        handleIssueClosureReviewedByChange(e)
                                                    }}
                                                    disabled={viewClicked}
                                                    className='form-control responsive-add-facility-input-fields' />
                                                <span style={{ color: "red", fontSize: "small" }}>{!isIssueClosureReviewedByValid && "Min of 3 and max of 200 letters required"}</span>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {issueStatus === 'completed' && (!issueClosureReviewedBy || issueClosureReviewedBy.length === 0) ? "Issue Closure Reviewed By is required" : ""}
                                                </span>
                                            </div>



                                        </div>
                                        <>
                                            <hr></hr>
                                            <h6>Edit History</h6>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: 10, padding: "0px" }}>

                                                <div>
                                                    {
                                                        editHistory?.created_by &&
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <span>Created By: {editHistory?.created_by?.name}</span>
                                                            <span>Created Date: {formatDateBasedOnValue(editHistory?.created_by?.action_time.split(" ")[0])} {editHistory?.created_by?.action_time?.split(" ")[1]}</span>
                                                        </div>
                                                    }

                                                </div>
                                                <div>
                                                    {
                                                        editHistory?.modified_by &&
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <span>Modified By: {editHistory?.modified_by?.name}</span>
                                                            <span>Modified Date: {formatDateBasedOnValue(editHistory?.modified_by?.action_time.split(" ")[0])} {editHistory?.modified_by?.action_time?.split(" ")[1]}</span>
                                                        </div>
                                                    }
                                                </div>
                                                <div>
                                                    {
                                                        editHistory?.approved_by &&
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <span>Reviewed By: {editHistory?.approved_by?.name}</span>
                                                            <span>Reviewed Date:{formatDateBasedOnValue(editHistory?.approved_by?.action_time.split(" ")[0])} {editHistory?.approved_by?.action_time?.split(" ")[1]}</span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </>

                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                        <div style={{ marginTop: "20px", }}>
                            <div style={{ display: "flex", justifyContent: "end", }}>
                                <button className="invoice_btn secondary-button"
                                    onClick={() => {
                                        handleCancelIssueClicked()
                                    }
                                    }
                                    style={{ marginTop: "20px", color: "white", marginRight: "10px" }} >Cancel</button>
                                {
                                    tabType === "issues" ?
                                        <>
                                            {
                                                !viewClicked ?
                                                    <>
                                                        {
                                                            !editClicked ?
                                                                <button className="invoice_btn primary-button" style={{ marginTop: "20px", color: "white" }}
                                                                    disabled={!issueReportedBy || !issueDate
                                                                        || !selectedOurCompany
                                                                        || !issueTime || !issueType || !issueStatus || !isIssueReportedByValid
                                                                        || !isIssueDateValid || !isIssueTypeValid || !isIssueStatusValid
                                                                        || !isIssueDescriptionValid || !isImmediateActionTakenValid
                                                                        || !isPreventiveActionTakenValid || !isCommentsValid || !isIssueClosureByValid
                                                                        || !isIssueClosurePreparedByValid || !isIssueClosureReviewedByValid || !isIssueCustomerNameValid
                                                                        || !isRootCauseAnalysisValid || !isCorrectiveActionTakenValid || (issueStatus === 'completed' && (!issueClosureBy || issueClosureBy.length === 0))
                                                                        || (issueStatus === 'completed' && (!issueClosurePreparedBy || issueClosurePreparedBy.length === 0))
                                                                        || (issueStatus === 'completed' && (!issueClosureReviewedBy || issueClosureReviewedBy.length === 0))
                                                                        || (issueStatus === 'completed' && (!issueClosureTime || issueClosureTime.length === 0)) || (issueStatus === 'completed' && (!issueDate || issueDate.length === 0))
                                                                    }
                                                                    onClick={() => { handleSaveIssueClicked() }}
                                                                >Save</button>
                                                                :
                                                                <button className="invoice_btn primary-button" style={{ marginTop: "20px", color: "white" }}
                                                                    disabled={!issueReportedBy || !issueDate || !issueTime || !issueType || !issueStatus || !isIssueReportedByValid
                                                                        || !isIssueDateValid || !isIssueTypeValid || !isIssueStatusValid
                                                                        || !selectedOurCompany
                                                                        || !isIssueDescriptionValid || !isImmediateActionTakenValid
                                                                        || !isPreventiveActionTakenValid || !isCommentsValid || !isIssueClosureByValid
                                                                        || !isIssueClosurePreparedByValid || !isIssueClosureReviewedByValid || !isIssueCustomerNameValid
                                                                        || !isRootCauseAnalysisValid || !isCorrectiveActionTakenValid || (issueStatus === 'completed' && (!issueClosureBy || issueClosureBy.length === 0))
                                                                        || (issueStatus === 'completed' && (!issueClosurePreparedBy || issueClosurePreparedBy.length === 0))
                                                                        || (issueStatus === 'completed' && (!issueClosureReviewedBy || issueClosureReviewedBy.length === 0))
                                                                        || (issueStatus === 'completed' && (!issueClosureTime || issueClosureTime.length === 0)) || (issueStatus === 'completed' && (!issueDate || issueDate.length === 0))
                                                                    }
                                                                    onClick={() => { handleUpdateIssueClicked() }}
                                                                >Update</button>

                                                        }

                                                    </>
                                                    :
                                                    null

                                            }
                                        </>
                                        :
                                        <button className="invoice_btn primary-button" style={{ marginTop: "20px", color: "white" }}
                                            onClick={() => { handleSaveIssueClicked() }}
                                        >Save</button>

                                }



                            </div>
                        </div>
                    </div>
                </div>

            }
            {
                currentPage === 3 &&
                <div className="newPaymentContainer">
                    <div style={{ display: "flex", flexDirection: "column", margin: '10px', marginBottom: "100px" }}>
                        <div>
                            <h2>Incident Details</h2>
                        </div>

                        <div style={{ marginTop: "20px" }}>
                            <Tabs
                                activeKey={activeTab}
                                onSelect={(k) => setActiveTab(k)}
                                id="uncontrolled-tab-example"
                                className="mb-0"
                            >
                                <Tab eventKey="1" title="Incident Details"
                                    className="assetTabs"
                                // disabled={!viewClicked && !editClicked}
                                >

                                    <div className="infoBody">
                                        <div>
                                            <div className="infoBodyInputs">
                                                <div className="responsiveInputSection">
                                                    <div>
                                                        <p style={{ marginBottom: "-18px" }}>Facility:&nbsp; <span style={{ color: "red" }}>*</span></p>
                                                        <SearchableDropdown
                                                            style={{ zIndex: 100 }}
                                                            className="searchable-dropdown2"
                                                            options={facilityList ? facilityList : []} //facilityList is the array of facilities
                                                            selectedOption={selectedfacility}
                                                            noOptionsAvailable="Facility unavailable"
                                                            onChange={(e) => {
                                                                setSelectedFacility(e.value)
                                                                const selectedFacility = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                                                setSelectedFacilityName(selectedFacility?.name);
                                                                setSelectedCityName(selectedFacility?.city);
                                                                setSelectedFacilityId(selectedFacility?.facility_id);
                                                                setIsFacilitySelected(true);
                                                            }}

                                                            placeholder="Select Facility"
                                                            isDisabled={viewClicked}
                                                        />
                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Incident Reported By <span style={{ color: "red" }}>*</span></label>
                                                        <input type='text'
                                                            value={incidentReportedBy}
                                                            disabled={viewClicked}
                                                            onChange={handleIncidentReportedByChange}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIncidentReportedByValid && "Min of 3 letters max of 200"}</span>

                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <label className='add-facility-modal-label'
                                                        >Incident Date <span style={{ color: "red" }}>*</span></label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label=""
                                                                disabled={viewClicked}
                                                                value={dayjs(incidentDate)}
                                                                className='form-control responsive-add-facility-input-fields'
                                                                views={['day', 'month', 'year']}
                                                                format={localStorage.getItem("date_format")}
                                                                // minDate={dayjs('2022-01-01')} // Set minimum selectable date
                                                                maxDate={dayjs(new Date())} // Set minimum selectable date
                                                                minDate={dayjs(new Date(new Date().setMonth(new Date().getMonth() - 1)))}
                                                                onChange={(newValue) => {
                                                                    handleIncidentDateChange(newValue);
                                                                }
                                                                }
                                                                sx={{
                                                                    '.MuiInputBase-root': {
                                                                        height: '40px', // Adjust height
                                                                        maxWidth: "250px",
                                                                        backgroundColor: 'white', // Set background to white
                                                                        borderRadius: '6px', // Optional: Rounded corners
                                                                        fontSize: '14px', // Optional: Adjust text size
                                                                    },
                                                                }}
                                                            // slotProps={{
                                                            //     textField: {
                                                            //         InputProps: {
                                                            //             readOnly: true, // Prevent typing in the input field
                                                            //         },
                                                            //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                                            //     },
                                                            // }}
                                                            />
                                                        </LocalizationProvider>

                                                    </div>



                                                </div>
                                                <div className="responsiveInputSection">

                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <label className='add-facility-modal-label'
                                                        >Incident Time <span style={{ color: "red" }}>*</span></label>



                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <TimePicker
                                                                value={dayjs(incidentTime, 'HH:mm:ss')}
                                                                disabled={viewClicked}
                                                                className='form-control responsive-add-facility-input-fields'
                                                                onChange={(newValue) => handleIncidentTimeChange(newValue)}
                                                                sx={{
                                                                    '.MuiInputBase-root': {
                                                                        height: '40px', // Adjust height
                                                                        maxWidth: "250px",
                                                                        backgroundColor: 'white', // Set background to white
                                                                        borderRadius: '6px', // Optional: Rounded corners
                                                                        fontSize: '14px', // Optional: Adjust text size
                                                                    },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Incident Type <span style={{ color: "red" }}>*</span></label>
                                                        <input type='text'
                                                            value={incidentType}
                                                            disabled={viewClicked}
                                                            onChange={handleIncidentTypeChange}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIncidentTypeValid && "Min of 3 letters max of 200"}</span>
                                                    </div>

                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Incident Status <span style={{ color: "red" }}>*</span></label>
                                                        <select
                                                            disabled={viewClicked}
                                                            value={incidentStatus}

                                                            onChange={(e) => {
                                                                handleIncidentStatusChange(e);
                                                            }}
                                                            className="form-select responsive-add-facility-input-fields invoice-select-date"
                                                            style={{ width: "100%", height: "2.5rem", margin: "0px" }}
                                                        >
                                                            <option value="pending">Pending</option>
                                                            <option value="completed">Completed</option>
                                                            { }
                                                        </select>

                                                    </div>


                                                </div>
                                                <div className="responsiveInputSection">
                                                    <div>
                                                        <label className='add-facility-modal-label'
                                                        >Customer Name </label>
                                                        <select style={{ margin: "0px" }}
                                                            className="form-select responsive-add-facility-input-fields invoice-select-date" disabled={viewClicked} value={JSON.stringify({ company_name: incidentCustomerName, customer_id: incidentCustomerId })} onChange={(e) => {
                                                                const selected = JSON.parse(e.target.value);
                                                                setIncidentCustomerName(selected.company_name);
                                                                setIncidentCustomerId(selected.customer_id);
                                                            }}>
                                                            <option hidden >Select a Customer</option>
                                                            {companyList?.map((company, index) => (
                                                                <option key={index} value={JSON.stringify({ company_name: company?.company_name, customer_id: company?.customer_id })}>{company?.company_name}</option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Our Company {<span style={{ color: "red" }}>*</span>}</label>
                                                        <select
                                                            disabled={viewClicked}
                                                            value={selectedOurCompany}
                                                            onChange={handleOurCompanyChange}
                                                            className='form-select '>
                                                            <option value="" hidden>Select Our Company</option>
                                                            {
                                                                billingEntities?.map((company) => (
                                                                    <option key={company.partner_company_id} value={company.partner_company_id}>
                                                                        {company.company_name}
                                                                    </option>
                                                                ))
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                                <hr></hr>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Brief Description of the Incident</label>
                                                        <textarea className='form-control'
                                                            value={incidentDescription}
                                                            disabled={viewClicked}

                                                            onChange={handleIncidentDescriptionChange}

                                                            placeholder='Description of the issue'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIncidentDescriptionValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Root cause analysis of the Incident</label>
                                                        <textarea className='form-control'
                                                            value={incidentRootCauseAnalysis}
                                                            disabled={viewClicked}

                                                            onChange={handleIncidentRootCauseAnalysisChange}

                                                            placeholder='Please add root cause analysis'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIncidentRootCauseAnalysisValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Immediate Action Taken</label>
                                                        <textarea className='form-control'
                                                            value={incidentImmediateActionTaken}
                                                            disabled={viewClicked}
                                                            onChange={handleIncidentImmediateActionTakenChange}

                                                            placeholder='Please add the immediate action taken'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIncidentImmediateActionTakenValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Corrective Action Taken</label>
                                                        <textarea className='form-control'
                                                            value={incidentCorrectiveActionTaken}
                                                            disabled={viewClicked}
                                                            onChange={handleIncidentCorrectiveActionTakenChange}

                                                            placeholder='Please add the corrective action taken'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIncidentCorrectiveActionTakenValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>


                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Preventive Action Taken</label>
                                                        <textarea className='form-control'
                                                            value={incidentPreventiveActionTaken}
                                                            disabled={viewClicked}

                                                            onChange={handleIncidentPreventiveActionTakenChange}

                                                            placeholder='Please add the preventive action taken'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIncidentPreventiveActionTakenValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>

                                                <div className="responsiveInputSection">
                                                    <div style={{ width: "100%" }}>
                                                        <label className='add-facility-modal-label'>Comments</label>
                                                        <textarea className='form-control'
                                                            disabled={viewClicked}

                                                            value={incidentComments}
                                                            onChange={handleIncidentCommentsChange}
                                                            placeholder='Please add your comment'
                                                            style={{ border: "0.5px solid #9D9D9C" }}
                                                        />
                                                        <span style={{ color: "red", fontSize: "small" }}>{!isIncidentCommentsValid && "Min of 3 letters required"}</span>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        <hr></hr>
                                        {
                                            selectedIncidentId &&
                                            <>
                                                <UploadComponent
                                                    onFilesSelected={handleFilesSelectedIncidents}
                                                    uploadMethod="single"
                                                    viewMode={viewClicked}
                                                    uploadedFileData={documentsListArray}
                                                    uploadActionClicked={handleDocumentUpload}
                                                    maxNumberOfFiles={5}
                                                    handleErrorFromDocument={handleErrorFromDocument}
                                                    idType={"incidents"}
                                                    acceptedFileTypes={".pdf, .jpeg, .jpg, .png"}
                                                />
                                                <hr></hr>

                                            </>


                                        }


                                        {/* <div className="infoBodyInputs"> */}
                                        <div className="responsiveInputSection">
                                            <div >
                                                <label className='add-facility-modal-label'
                                                >Incident Closure By </label>
                                                <input type='text'
                                                    style={{ width: "280px" }}
                                                    value={incidentClosureBy}
                                                    onChange={(e) => {
                                                        handleIncidentClosureByChange(e)
                                                    }}
                                                    disabled={viewClicked}
                                                    className='form-control responsive-add-facility-input-fields ' />
                                                <span style={{ color: "red", fontSize: "small" }}>{!isIncidentClosureByValid && "Min of 3 and max of 200 letters required"}</span>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {incidentStatus === 'completed' && (!incidentClosureBy || incidentClosureBy.length === 0) ? "Incident Closure By is required" : ""}
                                                </span>


                                            </div>

                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <label className='add-facility-modal-label'
                                                >Incident Closure Date</label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label=""
                                                        disabled={viewClicked}
                                                        value={dayjs(incidentClosureDate)}
                                                        views={['day', 'month', 'year']}
                                                        className='form-control responsive-add-facility-input-fields'
                                                        format={localStorage.getItem("date_format")}
                                                        minDate={dayjs(incidentDate)} // Set minimum selectable date
                                                        // maxDate={dayjs('2025-01-08')} // Set minimum selectable date
                                                        onChange={(newValue) => {
                                                            handleIncidentClosureDateChange(newValue);
                                                        }
                                                        }
                                                        sx={{
                                                            '.MuiInputBase-root': {
                                                                height: '40px', // Adjust height
                                                                maxWidth: "250px",
                                                                backgroundColor: 'white', // Set background to white
                                                                borderRadius: '6px', // Optional: Rounded corners
                                                                fontSize: '14px', // Optional: Adjust text size
                                                            },
                                                        }}
                                                    // slotProps={{
                                                    //     textField: {
                                                    //         InputProps: {
                                                    //             readOnly: true, // Prevent typing in the input field
                                                    //         },
                                                    //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                                    //     },
                                                    // }}
                                                    />
                                                </LocalizationProvider>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {incidentStatus === 'completed' && (!incidentClosureDate || incidentClosureDate.length === 0) ? "Incident Closure Date is required" : ""}
                                                </span>

                                            </div>

                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <label className='add-facility-modal-label'
                                                >Incident Closure Time </label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <TimePicker
                                                        value={dayjs(incidentClosureTime, 'HH:mm:ss')}
                                                        disabled={viewClicked}
                                                        className='form-control responsive-add-facility-input-fields'
                                                        onChange={(newValue) => handleIncidentClosureTimeChange(newValue)}
                                                        sx={{
                                                            '.MuiInputBase-root': {
                                                                height: '40px', // Adjust height
                                                                maxWidth: "250px",
                                                                backgroundColor: 'white', // Set background to white
                                                                borderRadius: '6px', // Optional: Rounded corners
                                                                fontSize: '14px', // Optional: Adjust text size
                                                            },
                                                        }}

                                                    />
                                                </LocalizationProvider>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {incidentStatus === 'completed' && (!incidentClosureTime || incidentClosureTime.length === 0) ? "Incident Closure Time is required" : ""}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="responsiveInputSection">
                                            <div>
                                                <label className='add-facility-modal-label'
                                                >Incident Closure Prepared By </label>
                                                <input type='text'
                                                    style={{ width: "280px" }}
                                                    value={incidentClosurePreparedBy}
                                                    onChange={(e) => {
                                                        handleIncidentClosurePreparedByChange(e)
                                                    }}
                                                    disabled={viewClicked}
                                                    className='form-control responsive-add-facility-input-fields' />
                                                <span style={{ color: "red", fontSize: "small" }}>{!isIncidentClosurePreparedByValid && "Min of 3 and max of 200 letters required"}</span>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {incidentStatus === 'completed' && (!incidentClosurePreparedBy || incidentClosurePreparedBy.length === 0) ? "Incident Closure Prepared By is required" : ""}
                                                </span>

                                            </div>

                                            <div >
                                                <label className='add-facility-modal-label'
                                                >Incident Closure Reviewed By </label>
                                                <input type='text'
                                                    style={{ width: "280px" }}
                                                    value={incidentClosureReviewedBy}
                                                    onChange={(e) => {
                                                        handleIncidentClosureReviewedByChange(e)
                                                    }}
                                                    disabled={viewClicked}
                                                    className='form-control responsive-add-facility-input-fields' />
                                                <span style={{ color: "red", fontSize: "small" }}>{!isIncidentClosureReviewedByValid && "Min of 3 and max of 200 letters required"}</span>
                                                <span style={{ color: "red", fontSize: "small" }}>
                                                    {incidentStatus === 'completed' && (!incidentClosureReviewedBy || incidentClosureReviewedBy.length === 0) ? "Incident Closure Reviewed By is required" : ""}
                                                </span>

                                            </div>




                                        </div>


                                        {/* </div> */}
                                        <>
                                            {
                                                (editClicked || viewClicked) ?

                                                    <>
                                                        <hr></hr>
                                                        <h6>Edit History</h6>
                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: 10, padding: "0px" }}>

                                                            <div>
                                                                {
                                                                    editHistory?.created_by &&
                                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                                        <span>Created By: {editHistory?.created_by?.name}</span>
                                                                        <span>Created Date: {formatDateBasedOnValue(editHistory?.created_by?.action_time.split(" ")[0])} {editHistory?.created_by?.action_time.split(" ")[1]}</span>
                                                                    </div>
                                                                }

                                                            </div>
                                                            <div>
                                                                {
                                                                    editHistory?.modified_by &&
                                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                                        <span>Modified By: {editHistory?.modified_by?.name}</span>
                                                                        <span>Modified Date: {formatDateBasedOnValue(editHistory?.modified_by?.action_time.split(" ")[0])} {editHistory?.modified_by?.action_time.split(" ")[1]}</span>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div>
                                                                {
                                                                    editHistory?.approved_by &&
                                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                                        <span>Reviewed By: {editHistory?.approved_by?.name}</span>
                                                                        <span>Reviewed Date: {formatDateBasedOnValue(editHistory?.approved_by?.action_time.split(" ")[0])} {editHistory?.approved_by?.action_time.split(" ")[1]}</span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>

                                                    </>
                                                    :
                                                    null
                                            }

                                        </>

                                    </div>




                                </Tab>
                            </Tabs>
                        </div>
                        <div style={{ marginTop: "20px", }}>
                            <div style={{ display: "flex", justifyContent: "end", }}>
                                <button className="invoice_btn secondary-button"
                                    onClick={() => {
                                        handleCancelIncidentClicked()
                                    }
                                    }
                                    style={{ marginTop: "20px", color: "white", marginRight: "10px" }}>Cancel</button>
                                {
                                    !viewClicked ?
                                        <>
                                            {
                                                !editClicked ?
                                                    <button className="invoice_btn primary-button" style={{ marginTop: "20px", color: "white" }}
                                                        disabled={!incidentReportedBy || !incidentDate || !incidentTime || !incidentType || !incidentStatus || !isIncidentReportedByValid
                                                            || !isIncidentTypeValid || !isIncidentStatusValid
                                                            || !isIncidentDescriptionValid || !isIncidentRootCauseAnalysisValid
                                                            || !isIncidentImmediateActionTakenValid || !isIncidentCorrectiveActionTakenValid
                                                            || !selectedOurCompany
                                                            || !isIncidentPreventiveActionTakenValid || !isIncidentCommentsValid || !isIncidentClosureByValid
                                                            || !isIncidentClosurePreparedByValid || !isIncidentClosureReviewedByValid || !isIncidentCustomerNameValid || (incidentStatus === 'completed' && (!incidentClosureBy || incidentClosureBy.length === 0)) || (incidentStatus === 'completed' && (!incidentClosureDate || incidentClosureDate.length === 0)) || (incidentStatus === 'completed' && (!incidentClosureTime || incidentClosureTime.length === 0)) || (incidentStatus === 'completed' && (!incidentClosurePreparedBy || incidentClosurePreparedBy.length === 0)) || (incidentStatus === 'completed' && (!incidentClosureReviewedBy || incidentClosureReviewedBy.length === 0))
                                                        }

                                                        onClick={() => { handleSaveIncidentClicked() }}
                                                    >Save</button>
                                                    :
                                                    <button className="invoice_btn primary-button" style={{ marginTop: "20px", color: "white" }}
                                                        disabled={
                                                            !incidentReportedBy || !incidentDate || !incidentType || !incidentStatus || !isIncidentReportedByValid
                                                            || !selectedOurCompany
                                                            || !isIncidentTypeValid || !isIncidentStatusValid
                                                            || !isIncidentDescriptionValid || !isIncidentRootCauseAnalysisValid
                                                            || !isIncidentImmediateActionTakenValid || !isIncidentCorrectiveActionTakenValid
                                                            || !isIncidentClosurePreparedByValid || !isIncidentClosureReviewedByValid || !isIncidentCustomerNameValid

                                                        }
                                                        onClick={() => { handleUpdateIncidentClicked() }}
                                                    >Update</button>

                                            }

                                        </>
                                        :
                                        null

                                }

                            </div>
                        </div>
                    </div>
                </div>
            }
            <Footer />
        </>

    )
}